module.exports = __webpack_public_path__ + "img/onetoko-logo.705c8729.png";